import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "auth";

export async function registerUser(request, returnUrl = "") {
  return await axiosInstance.post(`/${baseAPIUrl}/register?returnUrl=${encodeURIComponent(returnUrl)}`, request);
}
